import { put, select, takeLatest } from 'redux-saga/effects';
import { logger } from 'src/error';

import { api } from '../../../../api';

import { getPackageId, getIsManualPackage } from '../selectors/package';
import { getOrderFlight } from '../selectors/order';
import { getClientData } from '../../../../store/client/selectors';
import { getExtraRoomsIsRequestCreated } from '../selectors/extra-rooms';

import { CONFIRM_CLIENT } from '../constants/order';
import {
  GET_PACKAGES_FOR_ROOM_UPGRADE,
  CHECK_EXTRA_ROOM_REQUEST,
} from '../constants/extra-rooms';

import {
  getPackagesForRoomUpgradedAction,
  getPackagesForRoomUpgradedSuccessAction,
  getPackagesForRoomUpgradedFailAction,
} from '../actions/extra-rooms';

function* checkExtraRoomRequest(action) {
  const isManualPackage = yield select(getIsManualPackage);
  const isRequestCreated = yield select(getExtraRoomsIsRequestCreated);

  if (isRequestCreated || isManualPackage) {
    return;
  }

  yield put(getPackagesForRoomUpgradedAction(action.payload));
}

function* fetchExtraRoomUpgrade(action) {
  try {
    const packageId = yield select(getPackageId);
    const orderFlight = action.payload ?? (yield select(getOrderFlight));
    const client = yield select(getClientData);

    if (!client && !client.id) {
      return;
    }

    const params = {
      package_id: packageId,
      flight_pair_id: orderFlight,
      client_id: client.id,
    };
    const response = yield api.getPackagesPackagesForRoomUpgrade(params);

    const { success, packages, error } = response;

    if (success) {
      yield put(getPackagesForRoomUpgradedSuccessAction(packages));
    } else {
      yield put(getPackagesForRoomUpgradedFailAction(error));
    }
  } catch (error) {
    const errorMsg =
      'Extra rooms: Не удалось получить пакеты для улучшения номера';

    logger(error, errorMsg);
    yield put(getPackagesForRoomUpgradedFailAction(errorMsg));
  }
}

export default function* checkoutExtraRoomRequest() {
  yield takeLatest(
    [CONFIRM_CLIENT, CHECK_EXTRA_ROOM_REQUEST],
    checkExtraRoomRequest,
  );
  yield takeLatest(GET_PACKAGES_FOR_ROOM_UPGRADE, fetchExtraRoomUpgrade);
}
